/* Ultimate Giveaway (working name Prize drop), Black Friday 2026 peak 2 (sections/bf26-prize-drop.liquid). The Golden
   ticket's sign-up and draw in a paper cut-out look: the prizes drop in like paper landing, "Send It" cuts the card
   across, and what was won is stuck on top. The draw happens on the server (the Black Sheep app, /apps/bs/ticket, campaign "prize-drop"). */
(() => {
  const root = document.getElementById('bf26-prize-drop');
  const cfgEl = document.getElementById('bf26-prize-drop-config');
  if (!root || !cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch { return; }
  // Straight under <body>, out of Shopify's section wrapper, so the page around it can be made inert.
  document.body.append(root);

  const KEY = 'bf26-prize-drop';
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const params = new URLSearchParams(location.search);
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const local = {
    get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } },
    set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch {} },
  };
  const session = (k, v) => { try { if (v !== undefined) sessionStorage.setItem(k, v); return sessionStorage.getItem(k); } catch { return v ?? null; } };

  // A local dry-run draw on unpublished themes only (?ticket-api=, shared with the Golden ticket). Practice draw: on an
  // unpublished theme only, when the draw has no prize-drop window open (it doesn't take campaigns yet), the result is
  // made up here and its codes do nothing. A published theme never practises.
  let api = cfg.api.replace(/\/$/, '');
  const preview = window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main';
  if (preview && params.get('ticket-api')) session('bf26-gt-api', params.get('ticket-api'));
  if (preview && session('bf26-gt-api')) api = session('bf26-gt-api').replace(/\/$/, '');
  let practising = false;

  const state = local.get();
  if (cfg.pageType === 'collection') state.views = (state.views || 0) + 1;
  local.set(state);
  // ?prize-drop=show opens it now; in a practice draw, =win or =lose picks the result.
  const forced = ['show', 'win', 'lose'].includes(params.get('prize-drop')) || location.hash === '#prize-drop';
  const allowed = cfg.pageType !== 'cart' && cfg.types.includes(cfg.pageType);

  async function call(path, body) {
    const signal = AbortSignal.timeout?.(body ? 15000 : 6000);
    const url = `${api}/${path}?campaign=${encodeURIComponent(cfg.campaign)}`;
    const res = await fetch(url, body
      ? { method: 'POST', credentials: 'same-origin', signal, headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ ...body, campaign: cfg.campaign }) }
      : { credentials: 'same-origin', signal, headers: { accept: 'application/json' } });
    if (res.status === 429) return { ok: false, reason: 'slow-down' };
    if (!res.ok) throw new Error(String(res.status));
    return res.json();
  }
  const css = () => Promise.all(cfg.css.map((href) => new Promise((ok) => {
    if (document.querySelector(`link[href="${href}"]`)) return ok();
    const l = Object.assign(document.createElement('link'), { rel: 'stylesheet', href });
    l.onload = l.onerror = ok;
    document.head.append(l);
  })));

  let opened = false, lastFocus = null, busy = false;
  async function open({ force }) {
    if (opened) return;
    opened = true;
    let status = null;
    try { status = await call('status'); } catch {}
    // Only a draw that answers for this campaign counts; the Golden ticket's window is not this one.
    if (status && status.campaign !== cfg.campaign) status = null;
    // Practise only when asked for (?prize-drop=…), so a preview doesn't open it on top of the Golden ticket's practice.
    if (force && preview && !session('bf26-gt-api') && !status?.wholesale && !status?.played && !status?.open) { practising = true; status = { open: true }; }
    if (!status && !force) return; // fail closed
    if (status?.wholesale) return;
    if (!force && !status.open && !status.played) return;
    if (status?.played) { state.played = true; local.set(state); if (!force) return; }
    await css();
    if (cfg.signedIn) {
      $('[data-pd-guest]').hidden = true;
      $('[data-pd-member]').hidden = false;
      $('[data-pd-member]').textContent = cfg.firstName ? `You’re in, ${cfg.firstName}.` : 'You’re in.';
    }
    show();
    if (status?.played) reveal(status.played, { instant: true });
    else if (!status) closed('The giveaway is taking a breather. Try again soon.');
    else if (!status.open) closed('The giveaway isn’t on right now.');
  }

  function show() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('pd-open');
    for (const el of document.body.children) if (el !== root && !el.contains(root) && el.tagName !== 'SCRIPT') { el.dataset.pdInert = el.inert ? 'kept' : ''; el.inert = true; }
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-in')));
    $('.pd__dialog').focus({ preventScroll: true });
    setTimeout(() => (cfg.signedIn ? $('[data-pd-go]') : $('[data-pd-email]')).focus({ preventScroll: true }), still ? 0 : 1400);
  }
  function hide() {
    if (busy) return;
    root.classList.remove('is-in');
    root.hidden = true;
    document.documentElement.classList.remove('pd-open');
    for (const el of document.body.children) if ('pdInert' in el.dataset) { el.inert = el.dataset.pdInert === 'kept'; delete el.dataset.pdInert; }
    if (!state.played && cfg.snoozeDays > 0) { state.snoozedUntil = Date.now() + cfg.snoozeDays * 864e5; local.set(state); }
    lastFocus?.focus?.();
  }
  function closed(line) {
    $('.pd__intro').textContent = line;
    $('.pd__entry').hidden = true;
  }

  // The scissor cut: a jagged line drawn across the card, then the card falls apart along it.
  const jag = (n = 22) => Array.from({ length: n + 1 }, (_, i) => [i * (100 / n), 52 + (i % 2 ? -1 : 1) * (1.5 + Math.random() * 2.5)]);
  async function cut() {
    const card = $('[data-pd-card]');
    if (still) { card.style.visibility = 'hidden'; return; }
    const pts = jag();
    const line = $('[data-pd-cutline] path');
    line.setAttribute('d', `M ${pts.map(([x, y]) => `${x} ${y / 10}`).join(' L ')}`);
    root.classList.add('is-cutting');
    await wait(650);
    // Two copies of the card, clipped either side of the line, fall away; the card itself goes.
    const box = { left: card.offsetLeft, top: card.offsetTop, width: card.offsetWidth, height: card.offsetHeight };
    for (const side of ['top', 'bottom']) {
      const half = card.cloneNode(true);
      half.removeAttribute('data-pd-card');
      half.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      half.inert = true;
      half.setAttribute('aria-hidden', 'true');
      half.classList.add('pd__half', `pd__half--${side}`);
      Object.assign(half.style, { left: `${box.left}px`, top: `${box.top}px`, width: `${box.width}px`, height: `${box.height}px`,
        clipPath: side === 'top' ? `polygon(0 0, 100% 0, ${pts.slice().reverse().map(([x, y]) => `${x}% ${y}%`).join(', ')})`
          : `polygon(${pts.map(([x, y]) => `${x}% ${y}%`).join(', ')}, 100% 100%, 0 100%)` });
      card.parentNode.append(half);
      setTimeout(() => half.remove(), 1200);
    }
    card.style.visibility = 'hidden';
    root.classList.remove('is-cutting');
  }

  const REASONS = {
    email: 'Check your email address.',
    'not-open': 'The giveaway isn’t on yet.',
    closed: 'The giveaway has finished. Thanks for playing.',
    wholesale: 'Wholesale accounts aren’t in the draw.',
    busy: 'Still drawing. Try again in a minute.',
    'slow-down': 'Lots of plays from here. Try again later.',
  };
  async function play(e) {
    e.preventDefault();
    if (busy) return;
    const err = $('[data-pd-error]'), go = $('[data-pd-go]'), email = $('[data-pd-email]');
    if (!cfg.signedIn && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email.value.trim())) {
      err.textContent = REASONS.email;
      email.setAttribute('aria-invalid', 'true');
      return email.focus();
    }
    email.removeAttribute('aria-invalid');
    busy = true;
    go.dataset.label ||= go.textContent;
    go.disabled = true;
    go.textContent = 'Sending…';
    err.textContent = '';
    let out;
    try { out = practising ? await practice() : await call('play', { email: email.value.trim(), consent: true, source: cfg.pageType }); }
    catch { out = { ok: false, reason: 'network' }; }
    go.disabled = false;
    go.textContent = go.dataset.label;
    if (!out.ok) { busy = false; err.textContent = REASONS[out.reason] || 'Couldn’t reach the draw. Try again.'; return; }
    await cut();
    busy = false;
    reveal(out, {});
  }

  // Practice result (unpublished themes only): a main prize one time in four, unless ?prize-drop=win or =lose. The
  // prize table is the placeholder in the plan: 1 kit, 1 PURE pack, 1 TRC voucher, and the Golden ticket's red prizes.
  async function practice() {
    await wait(500);
    const ask = params.get('prize-drop');
    const big = ask === 'win' ? true : ask === 'lose' ? false : Math.random() < 0.25;
    const pick = (a) => a[Math.floor(Math.random() * a.length)];
    const bit = () => Math.random().toString(36).slice(2, 6).toUpperCase().padEnd(4, 'X');
    const prize = big
      ? pick([{ id: 'kit', label: 'A full kit', detail: '[Kit contents TBC]' }, { id: 'pure', label: 'A PURE prize pack', detail: '[Pack contents TBC]' }, { id: 'trc', label: 'A TRC voucher', detail: '[TRC voucher value TBC]' }])
      : pick([{ id: 'ship', label: 'Free shipping', detail: 'Free shipping on your next order' }, { id: 'ten', label: '$10 off', detail: '$10 off orders over $50' }, { id: 'twenty', label: '$20 off', detail: '$20 off orders over $150' }]);
    return { ok: true, kind: big ? 'major' : 'minor', prize, code: `${big ? 'DROP' : 'BF26'}-PREV-${bit()}`, preview: true,
      expiresAt: big ? undefined : new Date(Date.now() + 24 * 36e5).toISOString() };
  }

  let clock = null;
  function countdown(until) {
    clearInterval(clock);
    $('[data-pd-clock-wrap]').hidden = !until;
    if (!until) return;
    const end = Date.parse(until), el = $('[data-pd-clock]'), two = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      el.textContent = left ? `${two(Math.floor(left / 3600))}:${two(Math.floor(left / 60) % 60)}:${two(left % 60)}` : 'Ended';
      el.setAttribute('aria-label', left ? `${Math.floor(left / 3600)} hours ${Math.floor(left / 60) % 60} minutes left` : 'Ended');
      if (!left) clearInterval(clock);
    };
    tick();
    clock = setInterval(tick, 1000);
  }

  async function reveal(r, { instant }) {
    state.played = true;
    local.set(state);
    const major = r.kind === 'major' || r.kind === 'golden';
    const won = r.prize.label.charAt(0).toLowerCase() + r.prize.label.slice(1);
    root.classList.toggle('is-major', major);
    // A main prize's "You've won" sticker goes on its cut-out; the slip carries "Hell yeah!" for the rest.
    $('[data-pd-r-sticker]').textContent = 'Hell yeah!';
    $('[data-pd-r-sticker]').hidden = major;
    $('[data-pd-r-line]').textContent = major ? r.prize.label : `You have won ${won}.`;
    $('[data-pd-code-label]').textContent = major ? 'Your claim code' : 'Your code';
    $('[data-pd-code-wrap]').hidden = !r.code;
    $('[data-pd-code]').textContent = r.code || '';
    $('[data-pd-note]').textContent = [
      major ? `${r.prize.detail}. We’ll email you within two business days to sort it.` : `${r.prize.detail}. One use, at checkout.`,
      r.again ? 'You’ve played already, so this is what you won last time.' : '',
      r.preview ? (practising ? 'Practice draw on a preview theme: this code is made up.' : 'Preview: this code is made up.') : '',
    ].filter(Boolean).join(' ');
    countdown(!major && r.code && r.expiresAt);
    const apply = $('[data-pd-apply]');
    apply.hidden = major || !r.code;
    if (!apply.hidden) apply.href = `/discount/${encodeURIComponent(r.code)}?redirect=${encodeURIComponent('/cart')}`;
    // A main prize: its cut-out is stuck on top, big, with the "You've won" sticker.
    if (major && cfg.images[r.prize.id]) {
      $('[data-pd-won-img]').src = cfg.images[r.prize.id];
      $('[data-pd-won-sticker]').textContent = 'You’ve won';
      root.classList.add('is-won');
    }
    $('[data-pd-form]').inert = true;
    if (instant) $('[data-pd-card]').style.visibility = 'hidden';
    root.classList.add('is-revealed');
    if (!instant && !still) await wait(500);
    $('[data-pd-r-line]').setAttribute('tabindex', '-1');
    $('[data-pd-r-line]').focus({ preventScroll: true });
  }

  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); return hide(); }
    if (e.key !== 'Tab') return;
    const f = $$('button, a[href], input, [tabindex="-1"]').filter((el) => !el.disabled && !el.closest('[inert]') && !el.closest('[hidden]') && el.getClientRects().length && el !== $('.pd__dialog') && getComputedStyle(el).visibility !== 'hidden');
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.pd__dialog'))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-pd-close]')) return hide();
    if (e.target.closest('[data-pd-copy]')) {
      const b = e.target.closest('[data-pd-copy]');
      return navigator.clipboard?.writeText($('[data-pd-code]').textContent).then(() => { b.textContent = 'Copied'; setTimeout(() => { b.textContent = 'Copy'; }, 2000); });
    }
    if (!e.target.closest('[data-pd-poster]')) hide();
  });
  $('[data-pd-form]').addEventListener('submit', play);

  // Go: open now, after enough collection pages, or not at all.
  if (forced) open({ force: true });
  else if (allowed && !(cfg.suppressPlayed && state.played) && !(state.snoozedUntil > Date.now())) {
    if (!cfg.views || state.views >= cfg.views) open({});
  }
})();
